import React, { useState } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

export const VideoJS = (props) => {
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const [showPauseAd, setShowPauseAd] = useState(false);
  const {options, onReady} = props;

  React.useEffect(() => {

    // 确保 Video.js 播放器只初始化一次
    if (!playerRef.current) {
      // 在 React 18 严格模式下，Video.js 播放器需要在组件内部
      const videoElement = document.createElement("video-js");

      videoElement.classList.add('vjs-big-play-centered');
      videoRef.current.appendChild(videoElement);

      const player = playerRef.current = videojs(videoElement, options, () => {
        onReady && onReady(player);
      });

      // 监听播放和暂停事件
      player.on('pause', () => {
        setShowPauseAd(true);
      });

      player.on('play', () => {
        setShowPauseAd(false);
      });

    // 当 prop 发生改变时，在 else 语句块中你可以更新一个已存在的播放器
    } else {
      const player = playerRef.current;
      player.autoplay(options.autoplay);
      player.src(options.sources);
    }
  }, [options, onReady]);

  // 在函数组件卸载时释放 Video.js 播放器
  React.useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, []);

  return (
    <div className="max-w-[640px] mx-auto" data-vjs-player>
      <div ref={videoRef} />
      {/* <PauseAds visible={showPauseAd} /> */}
    </div>
  );
}

export default VideoJS;